// eslint-disable-next-line max-classes-per-file
import { CaseDisplay, HearingSection, UpdateCaseRequest } from '@ftr/annotations-contracts'
import { Uuid } from '@ftr/contracts/type/shared'
import { RemoteData } from '@ftr/foundation'

export class FetchCaseAction {
  static readonly type = '[Cases] Fetch Case'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class InitializeCaseDetailsAction {
  static readonly type = '[Cases] Initialize Case Details'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class FetchCaseDetailsAction {
  static readonly type = '[Cases] Fetch Case Details'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class InitializeHearingSectionsListAction {
  static readonly type = '[Cases] Initialize Hearing Sections List'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class FetchHearingSectionsListAction {
  static readonly type = '[Cases] Fetch Hearing Sections List'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class SelectHearingSectionAction {
  static readonly type = '[Cases] Select Hearing Section'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
    readonly hearingSectionId?: Uuid,
    readonly hearingSection?: Partial<Pick<HearingSection, 'id'>>,
  ) {}
}

export class FetchSelectedHearingSectionAction {
  static readonly type = '[Cases] Fetch Selected Hearing Section'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
    readonly hearingSectionId: Uuid,
    /**
     * Optional hearing section to simulate the fetch of hearing section details from the API
     *   This will be removed in later versions
     */
    readonly hearingSection?: Partial<Pick<HearingSection, 'id'>>,
  ) {}
}

export class SetCaseRemoteAction {
  static readonly type = '[Cases] Set Case Remote'

  constructor(
    readonly caseId: Uuid,
    readonly caseRemote: RemoteData<CaseDisplay>,
  ) {}
}

export class UpdateCaseAction {
  static readonly type = '[Cases] Update Case'

  constructor(
    readonly caseId: Uuid,
    readonly caseUpdate: UpdateCaseRequest,
  ) {}
}

export class UpdateCaseDetailsAction {
  static readonly type = '[Cases] Update Case Details'

  constructor(
    readonly caseId: Uuid,
    readonly caseUpdate: UpdateCaseRequest,
  ) {}
}

export class DeleteCaseAction {
  static readonly type = '[Cases] Delete Case'

  constructor(readonly caseId: Uuid) {}
}
